export default ({
    name : 'Content'
    , data () {
        return {
            noneIntroduceContentClass : 'none-introduce-content'
            , noneCategoryBannerClass : 'none-banner-zone'
            , noticeUrl : '/notice'
            , noticeSubQuery : '?not_id='
        }
    }
    , created () {
        this.code = 'product_basic';
        this.basic = this.getDetailDataByCode(this.code);
        this.notice = this.getDetailDataByCode('notice');
        return {}
    }
    , mounted () {
        this.adjustContainerPaddingTop();
        this.setBoxDivStyle();
    }
    , computed : {
        isUseBannerZone () {
            let codeData = this.getDetailDataByCode('banner_zone')
            return (codeData.use == 'Y')
        }
        , isUseIntroduceContent () {
            let codeData = this.getDetailDataByCode('introduce_content')
            return (codeData.use == 'Y')
        }
        , displayNotice() {
            return this.isSetNotice() ? this.notice.displayNotice : false;
        }
        , isNotice() {
            return this.isSetContentsNotice() ? this.notice.isNotice : false;
        }
        , noticeType() {
            return this.setNoticeType();
        }
        , noticeTitle() {
            return this.isSetContentsNotice() ? this.notice.data.not_title : '등록된 공지사항이 없습니다.';
        }
        , noticeLink() {
            return (this.notice.displayNotice && this.notice.isNotice) ? this.noticeUrl + this.noticeSubQuery + this.notice.data.not_id : 'javascript:;';
        } 
        , noticeListLink() {
            return (this.notice.displayNotice && this.notice.isNotice) ? this.noticeUrl : 'javascript:;';
        }
    }
    , methods : {
        adjustContainerPaddingTop () {
            let container = document.querySelector('#container')
            if (container.classList.contains(this.noneCategoryBannerClass) || container.classList.contains(this.noneIntroduceContentClass)) {
                let cateH = this.isUseCategory() ? 38 : 0
                container.style.paddingTop = (document.getElementById('header').offsetHeight + cateH) + 'px'
            } else {
                container.style.paddingTop = '0'
            }
        }
        , isUseCategory () { // 카테고리 사용 미사용으로 인한 UI 변경 필요한경우.
            let hamburgerMenuData = this.getDetailDataByCode('hamburger_menu')
            if (hamburgerMenuData.use == 'N') { return false; }
            if (typeof hamburgerMenuData.data.category_use == 'undefined' || hamburgerMenuData.data.category_use.value == 'N') { return false; }
            return true;
        }
        , isSetNotice () {
            return ((typeof this.notice != 'undefined') && this.notice.displayNotice)
        }
        , isSetContentsNotice () {
            return (this.isSetNotice() && this.notice.isNotice)
        }
        , setNoticeType() {
            let type = '';
            if (this.isSetContentsNotice()) {
                switch (this.notice.data.not_type) {
                    case 'EVENT':
                        type = '[이벤트]';
                        break;
                    case 'PRODUCT':
                        type = '[상품]';
                        break;
                    case 'NOTICE': 
                        type = '[공지사항]';
                        break;
                }
            }
            return type;
        }
        , setBoxDivStyle () {
			if (isMobile || self !== top) { 
				if ( $m('#container').find('#ft-bnrSlide-zone').length == 1 ) {
					$m('#tpl-blog #container .boxDiv').css('padding-bottom', '332px');
				} else {
					$m('#tpl-blog #container .boxDiv').css('padding-bottom', '47px');
				}

				if ( $m('#container').find('#ft-bnr-zone').length == 1 ) {
					$m('#tpl-design #container .boxDiv').css('padding-bottom', '107px');
					$m('#tpl-shop #container .boxDiv').css('padding-bottom', '107px');
				} else {
					$m('#tpl-design #container .boxDiv').css('padding-bottom', '47px');
					$m('#tpl-shop #container .boxDiv').css('padding-bottom', '47px');
				}
			}  else {
				if ( $m('#container').find('#ft-bnrSlide-zone').length == 1 ) {
					$m('#tpl-blog #container .boxDiv').css('padding-bottom', '532px');
				} else {
					$m('#tpl-blog #container .boxDiv').css('padding-bottom', '47px');
				}

				if ( $m('#container').find('#ft-bnr-zone').length == 1 ) {
					$m('#tpl-shop #container .boxDiv').css('padding-bottom', '167px');
					$m('#tpl-design #container .boxDiv').css('padding-bottom', '167px');
				} else {
					$m('#tpl-shop #container .boxDiv').css('padding-bottom', '47px');
					$m('#tpl-design #container .boxDiv').css('padding-bottom', '47px');
				}
			}
        }
    }
    , updated () {
        this.adjustContainerPaddingTop()
    }
})
